import styles from './CollectionProgressModule.module.css';

/**
 * Shows the collection the user is closest to completing.
 * Displays a progress bar and the next unverified title with a "Verify" CTA.
 * Hidden when collection is null (caller guards this).
 */
export default function CollectionProgressModule({ collection, onVerifyNext, onViewCollection }) {
    if (!collection) return null;

    const pct          = collection.total > 0 ? (collection.progress / collection.total) * 100 : 0;
    const nextTitle    = collection.items?.find(i => !i.verified) ?? null;

    return (
        <section className={styles.section}>
            <h2 className={styles.sectionTitle}>🏛️ Your Closest Collection</h2>
            <button className={styles.card} onClick={() => onViewCollection?.(collection.slug)}>
                <div className={styles.cardHeader}>
                    <span className={styles.collectionName}>{collection.name}</span>
                    <span className={styles.count}>{collection.progress}/{collection.total}</span>
                </div>
                <div className={styles.track}>
                    <div className={styles.fill} style={{ width: `${pct}%` }} />
                </div>
                {nextTitle && (
                    <div className={styles.nextRow} onClick={e => e.stopPropagation()}>
                        {nextTitle.posterUrl && (
                            <img src={nextTitle.posterUrl} alt="" className={styles.nextPoster} />
                        )}
                        <div className={styles.nextInfo}>
                            <span className={styles.nextLabel}>Next to verify</span>
                            <span className={styles.nextTitle}>{nextTitle.title ?? 'Unknown'}</span>
                        </div>
                        <button
                            className={styles.verifyBtn}
                            onClick={(e) => { e.stopPropagation(); onVerifyNext?.(nextTitle); }}
                        >
                            Verify →
                        </button>
                    </div>
                )}
            </button>
        </section>
    );
}